import React from "react";
import { num, dash } from "../utils/formatters";

/**
 * "Como cada tributo chega ao valor a recolher" — tabela do protótipo:
 * débito das notas | + lançamentos de débito | − crédito das notas |
 * − lançamentos de crédito | (− saldo credor anterior, só semanas) | = a recolher.
 */
export default function BreakdownTable({ p, isMes }) {
  const res = (r) => (isMes ? r.deb - r.cred : r.res);

  return (
    <div className="panel-card">
      <div className="panel-head">
        <div>
          <h5>Como cada tributo chega ao valor a recolher</h5>
          <p className="panel-sub">
            Débito e crédito das notas, mais os lançamentos manuais{" "}
            {isMes ? "das quatro semanas" : "desta semana"}. Em verde, o que vem
            dos parâmetros adicionados manualmente.
          </p>
        </div>
      </div>
      <div className="tablewrap">
        <table className="apura-table">
          <thead>
            <tr>
              <th>Tributo</th>
              <th className="r">Débito {isMes ? "(notas e lançamentos do mês)" : "das notas"}</th>
              <th className="r man">+ Lançamentos de débito</th>
              <th className="r">− Crédito {isMes ? "(notas e lançamentos do mês)" : "das notas"}</th>
              <th className="r man">− Lançamentos de crédito</th>
              {!isMes && <th className="r">− Saldo credor da semana anterior</th>}
              <th className="r">= A recolher</th>
            </tr>
          </thead>
          <tbody>
            {p.rows.map((r) => {
              const v = res(r);
              return (
                <tr key={r.t}>
                  <td>{r.k}</td>
                  <td className="r">{num(r.debN)}</td>
                  <td className={`r ${Math.abs(r.debM) > 0.005 ? "man" : ""}`}>{dash(r.debM)}</td>
                  <td className="r">{num(r.credN)}</td>
                  <td className={`r ${Math.abs(r.credM) > 0.005 ? "man" : ""}`}>{dash(r.credM)}</td>
                  {!isMes && <td className="r">{dash(r.carryIn)}</td>}
                  <td className={`r res ${v < -0.005 ? "neg" : ""}`}>
                    {num(v)}
                    {v < -0.005 && " (credor)"}
                    {!isMes && v >= -0.005 && r.carryOut > 0.005 &&
                      ` (credor ${num(r.carryOut)} p/ próx. semana)`}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td>
                ICMS-ST + DIFAL
                <span className="sub2">guias da aba ST</span>
              </td>
              <td className="r">–</td>
              <td className="r">–</td>
              <td className="r">–</td>
              <td className="r">–</td>
              {!isMes && <td className="r">–</td>}
              <td className="r res">{dash(p.st)}</td>
            </tr>
            <tr>
              <td>
                ISS
                <span className="sub2">{isMes ? "sobre serviços e locação" : "entra só no mês"}</span>
              </td>
              <td className="r">–</td>
              <td className="r">–</td>
              <td className="r">–</td>
              <td className="r">–</td>
              {!isMes && <td className="r">–</td>}
              <td className="r res">{dash(p.iss)}</td>
            </tr>
            <tr className="row-total">
              <td colSpan={isMes ? 5 : 6}>Total</td>
              <td className="r res">{num(isMes ? p.total : p.totalC)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
